<template>
  <div class="wrap-item">
    <div style="margin-bottom: 12px;">
      <p class="card-title">Tác vụ</p>
      <p class="card-subtitle">Thiết lập cấu hình, duyệt nhiều đơn xin nghỉ</p>
    </div>

    <div class="sk-dialog__footer flex justify-end items-center">
      <el-dropdown trigger="click" @command="handleExportCommand">
        <el-button type="success" style="min-width: 110px;">
          Tác vụ <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="constitutive">
            <i class="el-icon-setting"></i> Thiết lập đơn xin nghỉ
          </el-dropdown-item>
          <el-dropdown-item command="reason-config">
            <i class="el-icon-notebook-2"></i> Thiết lập lý do nghỉ
          </el-dropdown-item>
          <el-dropdown-item command="approve-multi">
            <i class="el-icon-check"></i> Duyệt đơn
          </el-dropdown-item>
          <el-dropdown-item command="delete-multi">
            <i class="el-icon-circle-close"></i> Xoá đơn
          </el-dropdown-item>
          <!--          <el-dropdown-item command="general-date">-->
          <!--            <i class="el-icon-files"></i> Xuất file chi tiết tháng-->
          <!--          </el-dropdown-item>-->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AbsentLetterTask',
  props: {
    isSaving: {type: Boolean, default: false}
  },
  methods: {
    /**
     * Hàm bắt sự kiện click vào từng dòng trong menu select dropdown
     * @param {string} command - Tên lệnh tương ứng với từng item
     */
    handleExportCommand(command) {
      this.$emit(command);
    }
  }
}
</script>

<style scoped>
.sk-dialog__footer {

}

.wrap-item {
  align-items: center;
  background: #ffffff;
  border-radius: 14px;
}

.card-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.card-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.ml-2 {
  margin-left: 0.5rem
}

/* Khoảng cách giữa nút Lưu và nút Menu */
.flex {
  display: flex
}

.justify-end {

}

.items-center {
  align-items: center
}
</style>